


// // import React, { useEffect, useState } from "react";
// // import { DataGrid } from "@mui/x-data-grid";
// // import { TextField,  Typography, Button, TextField as MUITextField } from "@mui/material";
// // import axios from "axios";

// // const ReferPharmacy
// //  = () => {
// //     const [searchText, setSearchText] = useState("");
// //     const [data, setData] = useState([]);
// //     const [error, setError] = useState(null);
    
  
// //     const handleSearchTextChange = (event) => {
// //       setSearchText(event.target.value);
// //     };
  
// //     const fetchreferPharmacy = async () => {
// //       try {
// //         const res = await axios.get("https://api.medstown.com/customer/getreferPharmacy");
// //         console.log(res.data)
// //         setData(res?.data.reverse() || []);
// //       } catch (error) {
// //         setError("Failed to fetch data");
// //         console.error(error);
// //       }
// //     };
  
// //     useEffect(() => {
// //         fetchreferPharmacy();
// //     }, []);
  
// //     const filteredRows = data.filter((row) =>
// //       Object.values(row).some(
// //         (value) =>
// //           value &&
// //           value.toString().toLowerCase().includes(searchText.toLowerCase())
// //       )
// //     );
  
// //     const tableColumns = [
// //         { field: "customerId", headerName: "User Id", width: 170 },
// //         { field: "customerName", headerName: "User Name", width: 170 },
// //         { field: "pharmacyName", headerName: "Pharmacy Name", width: 200 },
// //         { field: "pharmacyownername", headerName: "Pharmacy Owner Name", width: 200 },
// //         { field: "PharmacyMobileNumber", headerName: "Pharmacy Mobile Number", width: 200 },
// //         { field: "PharmacyLocation", headerName: "Pharmacy Location", width: 200 },
      
// //         // Combine date and time in one column
// //         { 
// //           field: "timedate", 
// //           headerName: "Created Date & Time", 
// //           width: 220, 
// //           valueGetter: (params) => {
// //             const date = new Date(params.row.timedate);
// //             return `${date.toLocaleDateString()}   |  ${date.toLocaleTimeString()}`;
// //           }
// //         }
// //       ];
   
  
    
// //     return (
// //       <div style={{ padding: "20px" }}>
// //         {error && <Typography color="error">{error}</Typography>}
// //         <TextField
// //           label="Search"
// //           variant="outlined"
// //           fullWidth
// //           value={searchText}
// //           onChange={handleSearchTextChange}
// //           style={{ marginBottom: "20px" }}
// //         />
// //         <div style={{ height: "700px" }}>
// //           <DataGrid
// //             rows={filteredRows}
// //             columns={tableColumns}
// //             pageSize={5}
// //             rowsPerPageOptions={[5]}
// //             disableSelectionOnClick
// //             sx={{ width: "100%" }}
// //             getRowId={(row) => row._id}
// //           />
// //         </div>
       
// //       </div>
// //     );
// //   };
  
// //   const modalStyle = {
// //     position: 'absolute',
// //     top: '50%',
// //     left: '50%',
// //     transform: 'translate(-50%, -50%)',
// //     width: 400,
// //     bgcolor: 'background.paper',
// //     border: '2px solid #000',
// //     boxShadow: 24,
// //     p: 4,
// //   };
  
// //   export default ReferPharmacy
// // ;
  


// import React, { useEffect, useState } from "react";
// import { DataGrid } from "@mui/x-data-grid";
// import {
//   TextField,
//   Typography,
//   Card,
//   Stack,
//   Chip,
//   Avatar,
//   useTheme,
//   alpha,
//   LinearProgress,
//   Skeleton,
//   Alert,
//   Container,
//   InputAdornment,
//   IconButton,
//   Paper,
//   Box,
//   Grid,
//   Tooltip,
// } from "@mui/material";
// import {
//   MdSearch,
//   MdClear,
//   MdStore,
//   MdPhone,
//   MdPerson,
//   MdLocationOn,
//   MdCalendarToday,
//   MdError,
//   MdGroup,
//   MdBusiness,
//   MdAccessTime,
//   // MdReferralLink,
// } from "react-icons/md";
// import axios from "axios";
// import dayjs from "dayjs";
// import isToday from "dayjs/plugin/isToday";
// import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
// import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

// // Extend dayjs with plugins
// dayjs.extend(isToday);
// dayjs.extend(isSameOrAfter);
// dayjs.extend(isSameOrBefore);

// const ReferPharmacy = () => {
//   const theme = useTheme();
//   const [searchText, setSearchText] = useState("");
//   const [data, setData] = useState([]);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [searchLoading, setSearchLoading] = useState(false);

//   // Medstown brand colors
//   const medstownColors = {
//     primary: "#014D4D",
//     secondary: "#02A0A0", 
//     accent: "#FFB800",
//     success: "#4caf50",
//     error: "#f44336",
//     warning: "#ff9800",
//   };

//   const handleSearchTextChange = (event) => {
//     setSearchText(event.target.value);
//     setSearchLoading(true);
//     setTimeout(() => setSearchLoading(false), 300);
//   };

//   const clearSearch = () => {
//     setSearchText("");
//   };

//   const fetchreferPharmacy = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const res = await axios.get("https://api.medstown.com/customer/getreferPharmacy");
//       console.log(res.data);
//       setData(res?.data.reverse() || []);
//     } catch (error) {
//       setError("Failed to fetch referral data. Please try again.");
//       console.error(error);
//       setData([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchreferPharmacy();
//   }, []);

//   const filteredRows = data.filter((row) =>
//     Object.values(row).some(
//       (value) =>
//         value &&
//         value.toString().toLowerCase().includes(searchText.toLowerCase())
//     )
//   );

//   // Helper function to count today's referrals
//   const getTodaysReferrals = () => {
//     return data.filter(item => {
//       try {
//         return dayjs(item.timedate).isToday();
//       } catch (error) {
//         // Fallback if date is invalid
//         const today = dayjs().startOf('day');
//         const itemDate = dayjs(item.timedate).startOf('day');
//         return today.isSame(itemDate);
//       }
//     }).length;
//   };

//   const tableColumns = [
//     {
//       field: "customerId",
//       headerName: "User Details (Name & Id)",
//       width: 250,
//       renderCell: (params) => (
//         <Stack spacing={0.5} sx={{ py: 0.5 }}>
//           <Stack direction="row" alignItems="center" spacing={1}>
//             {/* <Avatar sx={{ 
//               backgroundColor: alpha(medstownColors.primary, 0.1),
//               color: medstownColors.primary,
//               width: 28,
//               height: 28
//             }}>
//               <MdPerson size={16} />
//             </Avatar> */}
//             <Box>
//               <Typography variant="body2" fontWeight={700} sx={{ fontSize: '0.8rem' }}>
//                 {params.row.customerName || 'N/A'}
//               </Typography>
//               <Typography variant="caption" sx={{ 
//                 fontSize: '0.7rem',
//                 color: 'text.secondary',
//                 fontFamily: 'monospace'
//               }}>
//                 ID: {params.value || 'N/A'}
//               </Typography>
//             </Box>
//           </Stack>
//         </Stack>
//       ),
//     },
//     {
//       field: "pharmacyName",
//       headerName: "Pharmacy Info (Name & Owner Name)",
//       width: 280,
//       renderCell: (params) => (
//         <Stack spacing={0.5} sx={{ py: 0.5 }}>
//           <Stack direction="row" alignItems="center" spacing={1}>
//             <Avatar sx={{ 
//               backgroundColor: alpha(medstownColors.secondary, 0.1),
//               color: medstownColors.secondary,
//               width: 28,
//               height: 28
//             }}>
//               <MdStore size={16} />
//             </Avatar>
//             <Box>
//               <Typography variant="body2" fontWeight={700} sx={{ fontSize: '0.8rem' }}>
//                 {params.value || 'N/A'}
//               </Typography>
//               <Typography variant="caption" sx={{ 
//                 fontSize: '0.7rem',
//                 color: 'text.secondary'
//               }}>
//                 Owner: {params.row.pharmacyownername || 'N/A'}
//               </Typography>
//             </Box>
//           </Stack>
//         </Stack>
//       ),
//     },
//     {
//       field: "PharmacyMobileNumber",
//       headerName: "Contact",
//       width: 150,
//       renderCell: (params) => (
//         <Stack direction="row" alignItems="center" spacing={1}>
//           <MdPhone size={14} color={medstownColors.secondary} />
//           <Typography variant="body2" sx={{ 
//             fontFamily: 'monospace',
//             fontSize: '0.8rem'
//           }}>
//             {params.value || 'N/A'}
//           </Typography>
//         </Stack>
//       ),
//     },
//     {
//       field: "PharmacyLocation",
//       headerName: "Location",
//       width: 200,
//       renderCell: (params) => (
//         <Stack direction="row" alignItems="center" spacing={1}>
//           <MdLocationOn size={14} color={medstownColors.accent} />
//           <Typography variant="body2" sx={{ 
//             fontSize: '0.8rem',
//             overflow: 'hidden',
//             textOverflow: 'ellipsis',
//             display: '-webkit-box',
//             WebkitLineClamp: 2,
//             WebkitBoxOrient: 'vertical'
//           }}>
//             {params.value || 'N/A'}
//           </Typography>
//         </Stack>
//       ),
//     },
//     {
//       field: "timedate",
//       headerName: "Referral Date & Time",
//       width: 200,
//       renderCell: (params) => (
//         <Stack spacing={0.3}>
//           <Stack direction="row" alignItems="center" spacing={0.5}>
//             <MdCalendarToday size={12} color={theme.palette.text.secondary} />
//             <Typography variant="body2" sx={{ fontSize: '0.75rem', fontWeight: 500 }}>
//               {params.value ? dayjs(params.value).format("MMM DD, YYYY") : "N/A"}
//             </Typography>
//           </Stack>
//           <Stack direction="row" alignItems="center" spacing={0.5}>
//             <MdAccessTime size={12} color={theme.palette.text.secondary} />
//             <Typography variant="caption" sx={{ 
//               fontSize: '0.7rem',
//               color: 'text.secondary'
//             }}>
//               {params.value ? dayjs(params.value).format("hh:mm A") : "N/A"}
//             </Typography>
//           </Stack>
//         </Stack>
//       ),
//     },
//     // {
//     //   field: "status",
//     //   headerName: "Status",
//     //   width: 120,
//     //   renderCell: (params) => (
//     //     <Chip 
//     //       label="Referred"
//     //       size="small"
//     //       sx={{ 
//     //         fontSize: '0.7rem',
//     //         height: 22,
//     //         backgroundColor: alpha(medstownColors.success, 0.1),
//     //         color: medstownColors.success,
//     //         border: `1px solid ${alpha(medstownColors.success, 0.3)}`,
//     //         fontWeight: 600
//     //       }}
//     //     />
//     //   ),
//     // },
//   ];

//   if (loading) {
//     return (
//       <Container maxWidth="xl" sx={{ py: 2 }}>
//         <Card sx={{ borderRadius: 2, overflow: 'hidden' }}>
//           <Box sx={{ p: 2 }}>
//             <Skeleton variant="rectangular" height={50} sx={{ borderRadius: 1.5, mb: 1.5 }} />
//           </Box>
//           <Stack spacing={1.5} sx={{ p: 2 }}>
//             {Array.from(new Array(8)).map((_, index) => (
//               <Skeleton key={index} variant="rectangular" height={60} sx={{ borderRadius: 1 }} />
//             ))}
//           </Stack>
//         </Card>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="xl" sx={{ py: 2 }}>
//       {/* Enhanced Header with Medstown Colors */}
//       <Paper 
//         elevation={0} 
//         sx={{ 
//           p: 2, 
//           mb: 2, 
//           borderRadius: 2,
//           background: `linear-gradient(135deg, ${medstownColors.primary}, ${medstownColors.secondary})`,
//           color: 'white',
//           position: 'relative',
//           overflow: 'hidden'
//         }}
//       >
//         {/* Background Pattern */}
//         <Box
//           sx={{
//             position: 'absolute',
//             top: 0,
//             right: 0,
//             width: '100%',
//             height: '100%',
//             opacity: 0.1,
//             background: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.1"%3E%3Ccircle cx="7" cy="7" r="7"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")'
//           }}
//         />
        
//         <Stack direction="row" alignItems="center" spacing={2} sx={{ position: 'relative', zIndex: 1 }}>
//           <Avatar sx={{ 
//             backgroundColor: alpha('#ffffff', 0.2),
//             color: 'white',
//             width: 40,
//             height: 40
//           }}>
//             {/* <MdReferralLink size={20} /> */}
//           </Avatar>
          
//           <Box sx={{ flexGrow: 1 }}>
//             <Typography variant="h5" fontWeight={800} sx={{ mb: 0.5 }}>
//               Pharmacy Referrals
//             </Typography>
//             <Typography variant="body1" sx={{ opacity: 0.95 }}>
//               Customer referrals to pharmacy partners
//             </Typography>
//           </Box>
          
//           <Box textAlign="right">
//             <Typography variant="body1" sx={{ opacity: 0.8 }}>
//               Total Referrals
//             </Typography>
//             <Typography variant="h5" fontWeight={700}>
//               {filteredRows.length}
//             </Typography>
//           </Box>
//         </Stack>
//       </Paper>

//       {/* Error Alert */}
//       {error && (
//         <Alert 
//           severity="error" 
//           sx={{ mb: 2, borderRadius: 2, p: 1.5 }}
//           icon={<MdError size={18} />}
//           action={
//             <IconButton size="small" onClick={() => setError(null)}>
//               <MdClear size={16} />
//             </IconButton>
//           }
//         >
//           <Typography variant="body1">{error}</Typography>
//         </Alert>
//       )}

//       {/* Statistics Cards */}
//       <Grid container spacing={2} sx={{ mb: 2 }}>
//         <Grid item xs={12} sm={6} md={3}>
//           <Card sx={{ 
//             p: 2, 
//             borderRadius: 2,
//             background: `linear-gradient(135deg, ${alpha(medstownColors.success, 0.1)}, ${alpha(medstownColors.success, 0.05)})`,
//             border: `1px solid ${alpha(medstownColors.success, 0.2)}`,
//             transition: 'all 0.3s ease',
//             '&:hover': {
//               transform: 'translateY(-2px)',
//               boxShadow: `0 8px 16px ${alpha(medstownColors.success, 0.15)}`
//             }
//           }}>
//             <Stack direction="row" alignItems="center" spacing={1.5}>
//               <Avatar sx={{ 
//                 backgroundColor: medstownColors.success,
//                 color: 'white',
//                 width: 32,
//                 height: 32
//               }}>
//                 <MdGroup size={18} />
//               </Avatar>
//               <Box>
//                 <Typography variant="caption" color="text.secondary" fontWeight={500}>
//                   Total Users
//                 </Typography>
//                 <Typography variant="h6" fontWeight={700} color="success.main">
//                   {new Set(data.map(item => item.customerId)).size}
//                 </Typography>
//               </Box>
//             </Stack>
//           </Card>
//         </Grid>

//         <Grid item xs={12} sm={6} md={3}>
//           <Card sx={{ 
//             p: 2, 
//             borderRadius: 2,
//             background: `linear-gradient(135deg, ${alpha(medstownColors.primary, 0.1)}, ${alpha(medstownColors.primary, 0.05)})`,
//             border: `1px solid ${alpha(medstownColors.primary, 0.2)}`,
//             transition: 'all 0.3s ease',
//             '&:hover': {
//               transform: 'translateY(-2px)',
//               boxShadow: `0 8px 16px ${alpha(medstownColors.primary, 0.15)}`
//             }
//           }}>
//             <Stack direction="row" alignItems="center" spacing={1.5}>
//               <Avatar sx={{ 
//                 backgroundColor: medstownColors.primary,
//                 color: 'white',
//                 width: 32,
//                 height: 32
//               }}>
//                 <MdStore size={18} />
//               </Avatar>
//               <Box>
//                 <Typography variant="caption" color="text.secondary" fontWeight={500}>
//                   Total Pharmacies
//                 </Typography>
//                 <Typography variant="h6" fontWeight={700} color="primary.main">
//                   {new Set(data.map(item => item.pharmacyName)).size}
//                 </Typography>
//               </Box>
//             </Stack>
//           </Card>
//         </Grid>

//         <Grid item xs={12} sm={6} md={3}>
//           <Card sx={{ 
//             p: 2, 
//             borderRadius: 2,
//             background: `linear-gradient(135deg, ${alpha(medstownColors.accent, 0.1)}, ${alpha(medstownColors.accent, 0.05)})`,
//             border: `1px solid ${alpha(medstownColors.accent, 0.2)}`,
//             transition: 'all 0.3s ease',
//             '&:hover': {
//               transform: 'translateY(-2px)',
//               boxShadow: `0 8px 16px ${alpha(medstownColors.accent, 0.15)}`
//             }
//           }}>
//             <Stack direction="row" alignItems="center" spacing={1.5}>
//               <Avatar sx={{ 
//                 backgroundColor: medstownColors.accent,
//                 color: 'white',
//                 width: 32,
//                 height: 32
//               }}>
//                 <MdCalendarToday size={18} />
//               </Avatar>
//               <Box>
//                 <Typography variant="caption" color="text.secondary" fontWeight={500}>
//                   Today's Referrals
//                 </Typography>
//                 <Typography variant="h6" fontWeight={700} sx={{ color: medstownColors.accent }}>
//                   {/* Fixed: Using the helper function */}
//                   {getTodaysReferrals()}
//                 </Typography>
//               </Box>
//             </Stack>
//           </Card>
//         </Grid>

//         <Grid item xs={12} sm={6} md={3}>
//           <Card sx={{ 
//             p: 2, 
//             borderRadius: 2,
//             background: `linear-gradient(135deg, ${alpha(medstownColors.secondary, 0.1)}, ${alpha(medstownColors.secondary, 0.05)})`,
//             border: `1px solid ${alpha(medstownColors.secondary, 0.2)}`,
//             transition: 'all 0.3s ease',
//             '&:hover': {
//               transform: 'translateY(-2px)',
//               boxShadow: `0 8px 16px ${alpha(medstownColors.secondary, 0.15)}`
//             }
//           }}>
//             <Stack direction="row" alignItems="center" spacing={1.5}>
//               <Avatar sx={{ 
//                 backgroundColor: medstownColors.secondary,
//                 color: 'white',
//                 width: 32,
//                 height: 32
//               }}>
//                 <MdLocationOn size={18} />
//               </Avatar>
//               <Box>
//                 <Typography variant="caption" color="text.secondary" fontWeight={500}>
//                   Unique Locations
//                 </Typography>
//                 <Typography variant="h6" fontWeight={700} color="secondary.main">
//                   {new Set(data.map(item => item.PharmacyLocation)).size}
//                 </Typography>
//               </Box>
//             </Stack>
//           </Card>
//         </Grid>
//       </Grid>

//       {/* Rest of your component remains the same... */}
//       {/* Data Grid section */}
//       <Card elevation={0} sx={{ 
//         borderRadius: 2, 
//         border: `1px solid ${alpha(medstownColors.primary, 0.08)}`,
//         overflow: 'hidden'
//       }}>
//         {/* Search Header */}
//         <Box sx={{ p: 2, pb: 1.5 }}>
//           <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
//             <Box>
//               <Typography variant="body1" fontWeight={600} sx={{ mb: 0.5 }}>
//                 Referral Database
//               </Typography>
//               <Typography variant="caption" color="text.secondary">
//                 Complete referral history and customer-pharmacy connections
//               </Typography>
//             </Box>

//             <TextField
//               variant="outlined"
//               size="medium"
//               placeholder="Search referrals..."
//               value={searchText}
//               onChange={handleSearchTextChange}
//               sx={{
//                 width: 300,
//                 '& .MuiOutlinedInput-root': {
//                   backgroundColor: alpha(theme.palette.background.paper, 0.8),
//                   borderRadius: 2,
//                   '& fieldset': {
//                     borderColor: alpha(medstownColors.primary, 0.2),
//                   },
//                   '&:hover fieldset': {
//                     borderColor: alpha(medstownColors.primary, 0.4),
//                   },
//                   '&.Mui-focused fieldset': {
//                     borderColor: medstownColors.primary,
//                   },
//                 },
//               }}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     {searchLoading ? (
//                       <LinearProgress sx={{ width: 18, height: 2, borderRadius: 1 }} />
//                     ) : (
//                       <MdSearch size={18} color={medstownColors.primary} />
//                     )}
//                   </InputAdornment>
//                 ),
//                 endAdornment: searchText && (
//                   <InputAdornment position="end">
//                     <IconButton
//                       size="small"
//                       onClick={clearSearch}
//                       sx={{ width: 24, height: 24 }}
//                     >
//                       <MdClear size={16} />
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//           </Stack>
//         </Box>

//         {/* Data Grid */}
//         <Box sx={{ height: 600, px: 2, pb: 2 }}>
//           {filteredRows.length > 0 ? (
//             <DataGrid
//               rows={filteredRows}
//               columns={tableColumns}
//               pageSize={10}
//               rowsPerPageOptions={[5, 10, 20]}
//               disableSelectionOnClick
//               getRowId={(row) => row._id || Math.random()}
//               getRowHeight={() => 70}
//               sx={{
//                 border: 'none',
//                 '& .MuiDataGrid-main': {
//                   borderRadius: 1.5,
//                 },
//                 '& .MuiDataGrid-columnHeaders': {
//                   backgroundColor: alpha(medstownColors.primary, 0.06),
//                   borderRadius: '6px 6px 0 0',
//                   minHeight: '48px !important',
//                   '& .MuiDataGrid-columnHeader': {
//                     fontWeight: 700,
//                     color: medstownColors.primary,
//                     fontSize: '0.8rem',
//                     textTransform: 'uppercase',
//                     letterSpacing: '0.3px',
//                   },
//                 },
//                 '& .MuiDataGrid-row': {
//                   borderBottom: `1px solid ${alpha(medstownColors.primary, 0.1)}`,
//                   '&:hover': {
//                     backgroundColor: alpha(medstownColors.primary, 0.03),
//                     transform: 'translateY(-1px)',
//                     boxShadow: `0 2px 8px ${alpha(medstownColors.primary, 0.1)}`,
//                   },
//                   transition: 'all 0.2s ease',
//                 },
//                 '& .MuiDataGrid-cell': {
//                   borderBottom: 'none',
//                   fontSize: '0.8rem',
//                   padding: '8px 12px',
//                 },
//                 '& .MuiDataGrid-footerContainer': {
//                   backgroundColor: alpha(medstownColors.primary, 0.03),
//                   borderTop: `1px solid ${alpha(medstownColors.primary, 0.1)}`,
//                 },
//               }}
//             />
//           ) : (
//             <Box sx={{ 
//               display: 'flex', 
//               justifyContent: 'center', 
//               alignItems: 'center', 
//               height: 400,
//               flexDirection: 'column',
//               gap: 2
//             }}>
//               <Avatar sx={{ 
//                 backgroundColor: alpha(medstownColors.primary, 0.1),
//                 color: medstownColors.primary,
//                 width: 64,
//                 height: 64
//               }}>
//                 {/* <MdReferralLink size={32} /> */}
//               </Avatar>
//               <Typography variant="h6" color="text.secondary">
//                 No referral data available
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 {searchText ? 'Try adjusting your search terms' : 'Referral data will appear here when available'}
//               </Typography>
//             </Box>
//           )}
//         </Box>
//       </Card>
//     </Container>
//   );
// };

// export default ReferPharmacy;


import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  TextField,
  Typography,
  Card,
  Stack,
  Chip,
  Avatar,
  useTheme,
  alpha,
  LinearProgress,
  Skeleton,
  Alert,
  Container,
  InputAdornment,
  IconButton,
  Paper,
  Box,
  Grid,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import {
  MdSearch,
  MdClear,
  MdStore,
  MdPhone,
  MdPerson,
  MdLocationOn,
  MdCalendarToday,
  MdError,
  MdGroup,
  MdBusiness,
  MdAccessTime,
} from "react-icons/md";
import axios from "axios";
import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

// Extend dayjs with plugins
dayjs.extend(isToday);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

const ReferPharmacy = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const [searchText, setSearchText] = useState("");
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchLoading, setSearchLoading] = useState(false);

  // Medstown brand colors
  const medstownColors = {
    primary: "#014D4D",
    secondary: "#02A0A0", 
    accent: "#FFB800",
    success: "#4caf50",
    error: "#f44336",
    warning: "#ff9800",
  };

  const handleSearchTextChange = (event) => {
    setSearchText(event.target.value);
    setSearchLoading(true);
    setTimeout(() => setSearchLoading(false), 300);
  };

  const clearSearch = () => {
    setSearchText("");
  };

  const fetchreferPharmacy = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get("https://api.medstown.com/customer/getreferPharmacy");
      console.log(res.data);
      setData(res?.data.reverse() || []);
    } catch (error) {
      setError("Failed to fetch referral data. Please try again.");
      console.error(error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchreferPharmacy();
  }, []);

  const filteredRows = data.filter((row) =>
    Object.values(row).some(
      (value) =>
        value &&
        value.toString().toLowerCase().includes(searchText.toLowerCase())
    )
  );

  // Helper function to count today's referrals
  const getTodaysReferrals = () => {
    return data.filter(item => {
      try {
        return dayjs(item.timedate).isToday();
      } catch (error) {
        const today = dayjs().startOf('day');
        const itemDate = dayjs(item.timedate).startOf('day');
        return today.isSame(itemDate);
      }
    }).length;
  };

  // Responsive table columns with minimum widths for horizontal scroll
  const tableColumns = [
    {
      field: "customerId",
      headerName: isMobile ? "User" : "User Details (Name & Id)",
      minWidth: isMobile ? 140 : 250,
      flex: isMobile ? 0 : 1.2,
      renderCell: (params) => (
        <Stack spacing={0.5} sx={{ py: 0.5 }}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Avatar sx={{ 
              backgroundColor: alpha(medstownColors.primary, 0.1),
              color: medstownColors.primary,
              width: isMobile ? 24 : 28,
              height: isMobile ? 24 : 28
            }}>
              <MdPerson size={isMobile ? 12 : 16} />
            </Avatar>
            <Box sx={{ minWidth: 0 }}>
              <Typography 
                variant="body2" 
                fontWeight={700} 
                sx={{ 
                  fontSize: isMobile ? '0.7rem' : '0.8rem',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: isMobile ? 80 : 180
                }}
              >
                {params.row.customerName || 'N/A'}
              </Typography>
              {!isSmallMobile && (
                <Typography variant="caption" sx={{ 
                  fontSize: isMobile ? '0.6rem' : '0.7rem',
                  color: 'text.secondary',
                  fontFamily: 'monospace',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}>
                  ID: {params.value || 'N/A'}
                </Typography>
              )}
            </Box>
          </Stack>
        </Stack>
      ),
    },
    {
      field: "pharmacyName",
      headerName: isMobile ? "Pharmacy" : "Pharmacy Info (Name & Owner)",
      minWidth: isMobile ? 160 : 280,
      flex: isMobile ? 0 : 1.5,
      renderCell: (params) => (
        <Stack spacing={0.5} sx={{ py: 0.5 }}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Avatar sx={{ 
              backgroundColor: alpha(medstownColors.secondary, 0.1),
              color: medstownColors.secondary,
              width: isMobile ? 24 : 28,
              height: isMobile ? 24 : 28
            }}>
              <MdStore size={isMobile ? 12 : 16} />
            </Avatar>
            <Box sx={{ minWidth: 0 }}>
              <Typography 
                variant="body2" 
                fontWeight={700} 
                sx={{ 
                  fontSize: isMobile ? '0.7rem' : '0.8rem',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: isMobile ? 100 : 200
                }}
              >
                {params.value || 'N/A'}
              </Typography>
              {!isSmallMobile && (
                <Typography variant="caption" sx={{ 
                  fontSize: isMobile ? '0.6rem' : '0.7rem',
                  color: 'text.secondary',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}>
                  Owner: {params.row.pharmacyownername || 'N/A'}
                </Typography>
              )}
            </Box>
          </Stack>
        </Stack>
      ),
    },
    {
      field: "PharmacyMobileNumber",
      headerName: "Contact",
      minWidth: isMobile ? 120 : 150,
      flex: isMobile ? 0 : 1,
      renderCell: (params) => (
        <Stack direction="row" alignItems="center" spacing={1}>
          <MdPhone size={isMobile ? 12 : 14} color={medstownColors.secondary} />
          <Typography variant="body2" sx={{ 
            fontFamily: 'monospace',
            fontSize: isMobile ? '0.7rem' : '0.8rem',
            whiteSpace: 'nowrap'
          }}>
            {params.value || 'N/A'}
          </Typography>
        </Stack>
      ),
    },
    {
      field: "PharmacyLocation",
      headerName: "Location",
      minWidth: isMobile ? 120 : 200,
      flex: isMobile ? 0 : 1.2,
      renderCell: (params) => (
        <Stack direction="row" alignItems="center" spacing={1}>
          <MdLocationOn size={isMobile ? 12 : 14} color={medstownColors.accent} />
          <Tooltip title={params.value || 'N/A'} arrow>
            <Typography variant="body2" sx={{ 
              fontSize: isMobile ? '0.7rem' : '0.8rem',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              maxWidth: isMobile ? 80 : 150
            }}>
              {params.value || 'N/A'}
            </Typography>
          </Tooltip>
        </Stack>
      ),
    },
    {
      field: "timedate",
      headerName: isMobile ? "Date & Time" : "Referral Date & Time",
      minWidth: isMobile ? 120 : 200,
      flex: isMobile ? 0 : 1.2,
      renderCell: (params) => (
        <Stack spacing={0.3}>
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <MdCalendarToday size={isMobile ? 10 : 12} color={theme.palette.text.secondary} />
            <Typography variant="body2" sx={{ 
              fontSize: isMobile ? '0.65rem' : '0.75rem', 
              fontWeight: 500,
              whiteSpace: 'nowrap'
            }}>
              {params.value ? dayjs(params.value).format(isMobile ? "MMM DD" : "MMM DD, YYYY") : "N/A"}
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <MdAccessTime size={isMobile ? 10 : 12} color={theme.palette.text.secondary} />
            <Typography variant="caption" sx={{ 
              fontSize: isMobile ? '0.6rem' : '0.7rem',
              color: 'text.secondary',
              whiteSpace: 'nowrap'
            }}>
              {params.value ? dayjs(params.value).format("hh:mm A") : "N/A"}
            </Typography>
          </Stack>
        </Stack>
      ),
    },
    // Status column (optional - can be enabled if needed)
    ...(isMobile ? [] : [
      {
        field: "status",
        headerName: "Status",
        minWidth: 120,
        flex: 0.8,
        renderCell: (params) => (
          <Chip 
            label="Referred"
            size="small"
            sx={{ 
              fontSize: '0.7rem',
              height: 22,
              backgroundColor: alpha(medstownColors.success, 0.1),
              color: medstownColors.success,
              border: `1px solid ${alpha(medstownColors.success, 0.3)}`,
              fontWeight: 600
            }}
          />
        ),
      }
    ]),
  ];

  if (loading) {
    return (
      <Container maxWidth="xl" sx={{ py: isMobile ? 1 : 2, px: isMobile ? 1 : 3 }}>
        <Card sx={{ borderRadius: 2, overflow: 'hidden' }}>
          <Box sx={{ p: isMobile ? 1 : 2 }}>
            <Skeleton 
              variant="rectangular" 
              height={isMobile ? 40 : 50} 
              sx={{ borderRadius: 1.5, mb: 1.5 }} 
            />
          </Box>
          <Stack spacing={1.5} sx={{ p: isMobile ? 1 : 2 }}>
            {Array.from(new Array(isMobile ? 4 : 8)).map((_, index) => (
              <Skeleton 
                key={index} 
                variant="rectangular" 
                height={isMobile ? 50 : 60} 
                sx={{ borderRadius: 1 }} 
              />
            ))}
          </Stack>
        </Card>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ py: isMobile ? 1 : 2, px: isMobile ? 1 : 3 }}>
      {/* Responsive Header */}
      <Paper 
        elevation={0} 
        sx={{ 
          p: isMobile ? 1.5 : 2,
          mb: 2, 
          borderRadius: 2,
          background: `linear-gradient(135deg, ${medstownColors.primary}, ${medstownColors.secondary})`,
          color: 'white',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        <Stack 
          direction={isMobile ? "column" : "row"} 
          alignItems={isMobile ? "flex-start" : "center"} 
          spacing={isMobile ? 1 : 2} 
          sx={{ position: 'relative', zIndex: 1 }}
        >
          <Stack direction="row" alignItems="center" spacing={isMobile ? 1 : 2}>
            <Avatar sx={{ 
              backgroundColor: alpha('#ffffff', 0.2),
              color: 'white',
              width: isMobile ? 32 : 40,
              height: isMobile ? 32 : 40
            }}>
              <MdGroup size={isMobile ? 16 : 20} />
            </Avatar>
            
            <Box sx={{ flexGrow: 1 }}>
              <Typography 
                variant={isMobile ? "h6" : "h5"} 
                fontWeight={800} 
                sx={{ mb: 0.5 }}
              >
                {isMobile ? "Pharmacy Referrals" : "Pharmacy Referrals"}
              </Typography>
              <Typography 
                variant={isMobile ? "body2" : "body1"} 
                sx={{ opacity: 0.95 }}
              >
                {isMobile ? "Customer referrals" : "Customer referrals to pharmacy partners"}
              </Typography>
            </Box>
          </Stack>
          
          {/* <Box textAlign={isMobile ? "left" : "right"}>
            <Typography 
              variant={isMobile ? "body2" : "body1"} 
              sx={{ opacity: 0.8 }}
            >
              Total Referrals
            </Typography>
            <Typography 
              variant={isMobile ? "h6" : "h5"} 
              fontWeight={700}
            >
              {filteredRows.length}
            </Typography>
          </Box> */}
        </Stack>
      </Paper>

      {/* Error Alert */}
      {error && (
        <Alert 
          severity="error" 
          sx={{ mb: 2, borderRadius: 2, p: 1.5 }}
          icon={<MdError size={18} />}
          action={
            <IconButton size="small" onClick={() => setError(null)}>
              <MdClear size={16} />
            </IconButton>
          }
        >
          <Typography variant="body1">{error}</Typography>
        </Alert>
      )}

      {/* Responsive Statistics Cards */}
      <Grid container spacing={isMobile ? 1.5 : 2} sx={{ mb: 2 }}>
        <Grid item xs={6} sm={6} md={3}>
          <Card sx={{ 
            p: isMobile ? 1.5 : 2,
            borderRadius: 2,
            background: `linear-gradient(135deg, ${alpha(medstownColors.success, 0.1)}, ${alpha(medstownColors.success, 0.05)})`,
            border: `1px solid ${alpha(medstownColors.success, 0.2)}`,
            transition: 'all 0.3s ease',
            '&:hover': {
              transform: isMobile ? 'none' : 'translateY(-2px)',
              boxShadow: `0 8px 16px ${alpha(medstownColors.success, 0.15)}`
            }
          }}>
            <Stack direction="row" alignItems="center" spacing={isMobile ? 1 : 1.5}>
              <Avatar sx={{ 
                backgroundColor: medstownColors.success,
                color: 'white',
                width: isMobile ? 28 : 32,
                height: isMobile ? 28 : 32
              }}>
                <MdGroup size={isMobile ? 14 : 18} />
              </Avatar>
              <Box>
                <Typography 
                  variant="caption" 
                  color="text.secondary" 
                  fontWeight={500}
                  sx={{ fontSize: isMobile ? '0.7rem' : '0.75rem' }}
                >
                  {isMobile ? "Users" : "Total Users"}
                </Typography>
                <Typography 
                  variant={isMobile ? "body1" : "h6"} 
                  fontWeight={700} 
                  color="success.main"
                  sx={{ fontSize: isMobile ? '1rem' : '1.25rem' }}
                >
                  {new Set(data.map(item => item.customerId)).size}
                </Typography>
              </Box>
            </Stack>
          </Card>
        </Grid>

        <Grid item xs={6} sm={6} md={3}>
          <Card sx={{ 
            p: isMobile ? 1.5 : 2,
            borderRadius: 2,
            background: `linear-gradient(135deg, ${alpha(medstownColors.primary, 0.1)}, ${alpha(medstownColors.primary, 0.05)})`,
            border: `1px solid ${alpha(medstownColors.primary, 0.2)}`,
            transition: 'all 0.3s ease',
            '&:hover': {
              transform: isMobile ? 'none' : 'translateY(-2px)',
              boxShadow: `0 8px 16px ${alpha(medstownColors.primary, 0.15)}`
            }
          }}>
            <Stack direction="row" alignItems="center" spacing={isMobile ? 1 : 1.5}>
              <Avatar sx={{ 
                backgroundColor: medstownColors.primary,
                color: 'white',
                width: isMobile ? 28 : 32,
                height: isMobile ? 28 : 32
              }}>
                <MdStore size={isMobile ? 14 : 18} />
              </Avatar>
              <Box>
                <Typography 
                  variant="caption" 
                  color="text.secondary" 
                  fontWeight={500}
                  sx={{ fontSize: isMobile ? '0.7rem' : '0.75rem' }}
                >
                  {isMobile ? "Pharmacies" : "Total Pharmacies"}
                </Typography>
                <Typography 
                  variant={isMobile ? "body1" : "h6"} 
                  fontWeight={700} 
                  color="primary.main"
                  sx={{ fontSize: isMobile ? '1rem' : '1.25rem' }}
                >
                  {new Set(data.map(item => item.pharmacyName)).size}
                </Typography>
              </Box>
            </Stack>
          </Card>
        </Grid>

        <Grid item xs={6} sm={6} md={3}>
          <Card sx={{ 
            p: isMobile ? 1.5 : 2,
            borderRadius: 2,
            background: `linear-gradient(135deg, ${alpha(medstownColors.accent, 0.1)}, ${alpha(medstownColors.accent, 0.05)})`,
            border: `1px solid ${alpha(medstownColors.accent, 0.2)}`,
            transition: 'all 0.3s ease',
            '&:hover': {
              transform: isMobile ? 'none' : 'translateY(-2px)',
              boxShadow: `0 8px 16px ${alpha(medstownColors.accent, 0.15)}`
            }
          }}>
            <Stack direction="row" alignItems="center" spacing={isMobile ? 1 : 1.5}>
              <Avatar sx={{ 
                backgroundColor: medstownColors.accent,
                color: 'white',
                width: isMobile ? 28 : 32,
                height: isMobile ? 28 : 32
              }}>
                <MdCalendarToday size={isMobile ? 14 : 18} />
              </Avatar>
              <Box>
                <Typography 
                  variant="caption" 
                  color="text.secondary" 
                  fontWeight={500}
                  sx={{ fontSize: isMobile ? '0.7rem' : '0.75rem' }}
                >
                  {isMobile ? "Today" : "Today's Referrals"}
                </Typography>
                <Typography 
                  variant={isMobile ? "body1" : "h6"} 
                  fontWeight={700} 
                  sx={{ 
                    color: medstownColors.accent,
                    fontSize: isMobile ? '1rem' : '1.25rem'
                  }}
                >
                  {getTodaysReferrals()}
                </Typography>
              </Box>
            </Stack>
          </Card>
        </Grid>

        <Grid item xs={6} sm={6} md={3}>
          <Card sx={{ 
            p: isMobile ? 1.5 : 2,
            borderRadius: 2,
            background: `linear-gradient(135deg, ${alpha(medstownColors.secondary, 0.1)}, ${alpha(medstownColors.secondary, 0.05)})`,
            border: `1px solid ${alpha(medstownColors.secondary, 0.2)}`,
            transition: 'all 0.3s ease',
            '&:hover': {
              transform: isMobile ? 'none' : 'translateY(-2px)',
              boxShadow: `0 8px 16px ${alpha(medstownColors.secondary, 0.15)}`
            }
          }}>
            <Stack direction="row" alignItems="center" spacing={isMobile ? 1 : 1.5}>
              <Avatar sx={{ 
                backgroundColor: medstownColors.secondary,
                color: 'white',
                width: isMobile ? 28 : 32,
                height: isMobile ? 28 : 32
              }}>
                <MdLocationOn size={isMobile ? 14 : 18} />
              </Avatar>
              <Box>
                <Typography 
                  variant="caption" 
                  color="text.secondary" 
                  fontWeight={500}
                  sx={{ fontSize: isMobile ? '0.7rem' : '0.75rem' }}
                >
                  {isMobile ? "Locations" : "Unique Locations"}
                </Typography>
                <Typography 
                  variant={isMobile ? "body1" : "h6"} 
                  fontWeight={700} 
                  color="secondary.main"
                  sx={{ fontSize: isMobile ? '1rem' : '1.25rem' }}
                >
                  {new Set(data.map(item => item.PharmacyLocation)).size}
                </Typography>
              </Box>
            </Stack>
          </Card>
        </Grid>
      </Grid>

      {/* Responsive Data Grid with Horizontal Scroll */}
      <Card elevation={0} sx={{ 
        borderRadius: 2, 
        border: `1px solid ${alpha(medstownColors.primary, 0.08)}`,
        overflow: 'hidden'
      }}>
        {/* Search Header */}
        <Box sx={{ p: isMobile ? 1.5 : 2, pb: isMobile ? 1 : 1.5 }}>
          <Stack 
            direction={isMobile ? "column" : "row"} 
            justifyContent="space-between" 
            alignItems={isMobile ? "stretch" : "center"} 
            spacing={2}
          >
            <Box>
              <Typography 
                variant={isMobile ? "body2" : "body1"} 
                fontWeight={600} 
                sx={{ mb: 0.5 }}
              >
                Referral Database
              </Typography>
              <Typography 
                variant="caption" 
                color="text.secondary"
                sx={{ fontSize: isMobile ? '0.7rem' : '0.75rem' }}
              >
                {isMobile 
                  ? "Complete referral history" 
                  : "Complete referral history and customer-pharmacy connections"
                }
              </Typography>
            </Box>

            <TextField
              variant="outlined"
              size={isMobile ? "small" : "medium"}
              fullWidth={isMobile}
              placeholder={isMobile ? "Search referrals..." : "Search referrals..."}
              value={searchText}
              onChange={handleSearchTextChange}
              sx={{
                width: isMobile ? '100%' : 300,
                '& .MuiOutlinedInput-root': {
                  backgroundColor: alpha(theme.palette.background.paper, 0.8),
                  borderRadius: 2,
                  fontSize: isMobile ? '0.8rem' : '1rem',
                  '& fieldset': {
                    borderColor: alpha(medstownColors.primary, 0.2),
                  },
                  '&:hover fieldset': {
                    borderColor: alpha(medstownColors.primary, 0.4),
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: medstownColors.primary,
                  },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {searchLoading ? (
                      <LinearProgress sx={{ width: 18, height: 2, borderRadius: 1 }} />
                    ) : (
                      <MdSearch size={isMobile ? 16 : 18} color={medstownColors.primary} />
                    )}
                  </InputAdornment>
                ),
                endAdornment: searchText && (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={clearSearch}
                      sx={{ width: 24, height: 24 }}
                    >
                      <MdClear size={16} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Stack>
        </Box>

        {/* Data Grid with Horizontal Scroll */}
        <Box sx={{ 
          height: isMobile ? 400 : 600, 
          px: isMobile ? 0.5 : 2, 
          pb: isMobile ? 0.5 : 2,
          // Enable horizontal scroll
          overflowX: 'auto',
          width: '100%'
        }}>
          {filteredRows.length > 0 ? (
            <DataGrid
              rows={filteredRows}
              columns={tableColumns}
              pageSize={isMobile ? 6 : 10}
              rowsPerPageOptions={isMobile ? [5, 6, 10] : [5, 10, 20]}
              disableSelectionOnClick
              getRowId={(row) => row._id || Math.random()}
              getRowHeight={() => isMobile ? 60 : 70}
              sx={{
                border: 'none',
                // Set minimum width for horizontal scroll
                minWidth: isMobile ? 700 : 900,
                width: '100%',
                '& .MuiDataGrid-main': {
                  borderRadius: 1.5,
                },
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: alpha(medstownColors.primary, 0.06),
                  borderRadius: '6px 6px 0 0',
                  minHeight: `${isMobile ? 40 : 48}px !important`,
                  '& .MuiDataGrid-columnHeader': {
                    fontWeight: 700,
                    color: medstownColors.primary,
                    fontSize: isMobile ? '0.7rem' : '0.8rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.3px',
                  },
                },
                '& .MuiDataGrid-row': {
                  borderBottom: `1px solid ${alpha(medstownColors.primary, 0.1)}`,
                  '&:hover': {
                    backgroundColor: alpha(medstownColors.primary, 0.03),
                    transform: isMobile ? 'none' : 'translateY(-1px)',
                    boxShadow: isMobile ? 'none' : `0 2px 8px ${alpha(medstownColors.primary, 0.1)}`,
                  },
                  transition: 'all 0.2s ease',
                },
                '& .MuiDataGrid-cell': {
                  borderBottom: 'none',
                  fontSize: isMobile ? '0.7rem' : '0.8rem',
                  padding: isMobile ? '6px 8px' : '8px 12px',
                },
                '& .MuiDataGrid-footerContainer': {
                  backgroundColor: alpha(medstownColors.primary, 0.03),
                  borderTop: `1px solid ${alpha(medstownColors.primary, 0.1)}`,
                },
                // Ensure horizontal scroll works properly
                '& .MuiDataGrid-virtualScroller': {
                  minWidth: '100%',
                },
              }}
            />
          ) : (
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              height: isMobile ? 300 : 400,
              flexDirection: 'column',
              gap: 2
            }}>
              <Avatar sx={{ 
                backgroundColor: alpha(medstownColors.primary, 0.1),
                color: medstownColors.primary,
                width: isMobile ? 48 : 64,
                height: isMobile ? 48 : 64
              }}>
                <MdGroup size={isMobile ? 24 : 32} />
              </Avatar>
              <Typography 
                variant={isMobile ? "body1" : "h6"} 
                color="text.secondary"
              >
                No referral data available
              </Typography>
              <Typography 
                variant="body2" 
                color="text.secondary"
                sx={{ fontSize: isMobile ? '0.8rem' : '0.875rem' }}
              >
                {searchText ? 'Try adjusting your search terms' : 'Referral data will appear here when available'}
              </Typography>
            </Box>
          )}
        </Box>
      </Card>
    </Container>
  );
};

export default ReferPharmacy;
